import { BaseApiService } from "@mirage/services/BaseApiService";
import { IEntityPageResult } from "@shared/mirage/core/contracts/IEntityPageResult";
import { IPlanningApplicationsService } from "@shared/publicportal/services/IPlanningApplicationsService";
import { IPlanningApplicationDetails } from "@shared/publicportal/contracts/IPlanningApplicationDetails";
import { IPlanningApplicationsFilteringLists } from "@shared/publicportal/contracts/PlanningApplicationsFilteringLists";
import { IEntityPageRequest } from "@shared/mirage/core/contracts/IEntityPageRequest";
import { IPApplication } from "@shared/publicportal/entities/IPApplication";
import { IPGeneralConstraintResult } from "@shared/publicportal/entities/IPGeneralConstraintResult";
import { IPPlanningConstraintResult } from "@shared/publicportal/entities/IPPlanningConstraintResult";

export default class PlanningApplicationsService extends BaseApiService implements IPlanningApplicationsService {
    constructor() {
        super("publicportal/planningApplications");
    }

    async getFilteringLists(): Promise<IPlanningApplicationsFilteringLists> {
        const existingFilters = sessionStorage.getItem("publicportal.PlanningApplicationsService.dictionaries");
        if (!existingFilters) {
            const response = await this.httpInstance().get("/filters");
            const filters = response.data;
            sessionStorage.setItem("publicportal.PlanningApplicationsService.dictionaries", JSON.stringify(filters));
            return filters;
        }
        return JSON.parse(existingFilters);
    }

    async getPlanningApplicationById(appId: number): Promise<IPlanningApplicationDetails> {
        const response = await this.httpInstance().get(`/${appId}`);
        return response.data;
    }

    async pageRequest(pr: IEntityPageRequest): Promise<IEntityPageResult<IPApplication>> {
        const response = await this.httpInstance().post("/pageRequest", pr);
        return response.data;
    }

    async generalConstraintsPageRequest(pr: IEntityPageRequest): Promise<IEntityPageResult<IPGeneralConstraintResult>> {
        const response = await this.httpInstance().post("/generalConstraintsPageRequest", pr);
        return response.data;
    }

    async planningConstraintsPageRequest(pr: IEntityPageRequest): Promise<IEntityPageResult<IPPlanningConstraintResult>> {
        const response = await this.httpInstance().post("/planningConstraintsPageRequest", pr);
        return response.data;
    }
}
